<template>
    <div class="table-responsive">
        <table class="table-bordered table">
            <colgroup>
                <col style="width: 200px" />
                <col style="width: auto" />
                <col style="width: 150px" />
                <col style="width: 150px" />
            </colgroup>
            <tbody>
                <tr>
                    <th>■CP概要</th>
                    <th></th>
                    <th>1次チェック</th>
                    <th>2次チェック</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['宛先']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                v-model="SWITCH_FIELD_TAB_2(dataObject)['宛先']"
                                switch
                                @change="toggleCommonSwitch($event, { address: dataObject.address })"
                            />
                            宛先
                        </div>
                    </td>
                    <td>
                        <div
                            :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['宛先'] ? 'disabled_input' : ''}`"
                            :style="{
                                'background-color': isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['宛先'] ? '' : '#ffffff',
                                'min-height': '37px'
                            }"
                            v-html="dataObject.address.data"
                        ></div>
                    </td>
                    <td>
                        <CommonCheckbox
                            v-model="dataObject.address.first_check"
                            :currentUser="currentUser"
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_first)"
                            @input="handleCheckBoxValue('address', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            v-model="dataObject.address.secondary_check"
                            :currentUser="currentUser"
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_secondary)"
                            @input="handleCheckBoxValue('address', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['■CP概要その他先_2']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_2(dataObject)['■CP概要その他先_2']"
                            @change="toggleCommonSwitch($event, { free_block_campaign_overview: dataObject.free_block_campaign_overview })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_campaign_overview.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['■CP概要その他先_2']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['■CP概要その他先_2'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_campaign_overview.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-■CP概要その他先_2-${idTab}`"
                            :model.sync="dataObject.free_block_campaign_overview.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['■CP概要その他先_2'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
                <tr>
                    <th colspan="4">■応募数報告</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['報告スケジュール']">
                    <tr>
                        <td rowspan="2" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    v-model="SWITCH_FIELD_TAB_2(dataObject)['報告スケジュール']"
                                    switch
                                    @change="
                                        toggleCommonSwitch($event, {
                                            reporting_schedule: dataObject.reporting_schedule,
                                            reporting_schedule_detail: dataObject.reporting_schedule_detail
                                        })
                                    "
                                />
                                報告スケジュール
                            </div>
                        </td>
                        <td>
                            <InputText
                                :model.sync="dataObject.reporting_schedule.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['報告スケジュール']"
                                :config="inputConfig.reporting_schedule"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.reporting_schedule.first_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_first)"
                                @input="handleCheckBoxValue('reporting_schedule', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.reporting_schedule.secondary_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_secondary)"
                                @input="handleCheckBoxValue('reporting_schedule', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab2-textarea-1"
                                :model.sync="dataObject.reporting_schedule_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['報告スケジュール']"
                                :isPreview="isPreview"
                                :config="inputConfig.reporting_schedule_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.reporting_schedule_detail.first_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_detail_first)"
                                @input="handleCheckBoxValue('reporting_schedule_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.reporting_schedule_detail.secondary_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_detail_secondary)"
                                @input="handleCheckBoxValue('reporting_schedule_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['仕分け方法']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                v-model="SWITCH_FIELD_TAB_2(dataObject)['仕分け方法']"
                                switch
                                @change="toggleCommonSwitch($event, { sorting_method: dataObject.sorting_method })"
                            />
                            仕分け方法
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab2-textarea-2"
                            :model.sync="dataObject.sorting_method.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['仕分け方法']"
                            :isPreview="isPreview"
                            :config="inputConfig.sorting_method"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            v-model="dataObject.sorting_method.first_check"
                            :currentUser="currentUser"
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.sorting_method_first)"
                            @input="handleCheckBoxValue('sorting_method', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            v-model="dataObject.sorting_method.secondary_check"
                            :currentUser="currentUser"
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.sorting_method_secondary)"
                            @input="handleCheckBoxValue('sorting_method', 'secondary')"
                        />
                    </td>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['報告内容']">
                    <tr>
                        <td rowspan="3" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    v-model="SWITCH_FIELD_TAB_2(dataObject)['報告内容']"
                                    switch
                                    @change="
                                        toggleCommonSwitch($event, {
                                            contents_of_report: dataObject.contents_of_report,
                                            contents_of_report_detail: dataObject.contents_of_report_detail,
                                            contents_of_report_expiration_date: dataObject.contents_of_report_expiration_date
                                        })
                                    "
                                />
                                報告内容
                            </div>
                        </td>
                        <td
                            :class="{
                                disabled_cursor: isDisabled
                            }"
                        >
                            <CommonMultiselect
                                v-model="dataObject.contents_of_report.data"
                                :options.sync="option.contents_of_report"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['報告内容']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.contents_of_report.first_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_first)"
                                @input="handleCheckBoxValue('contents_of_report', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.contents_of_report.secondary_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_secondary)"
                                @input="handleCheckBoxValue('contents_of_report', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab2-textarea-3"
                                :model.sync="dataObject.contents_of_report_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['報告内容']"
                                :isPreview="isPreview"
                                :config="inputConfig.contents_of_report_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.contents_of_report_detail.first_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_detail_first)"
                                @input="handleCheckBoxValue('contents_of_report_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.contents_of_report_detail.secondary_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_detail_secondary)"
                                @input="handleCheckBoxValue('contents_of_report_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab2-textarea-4"
                                :model.sync="dataObject.contents_of_report_expiration_date.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['報告内容']"
                                :isPreview="isPreview"
                                :config="inputConfig.contents_of_report_expiration_date"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.contents_of_report_expiration_date.first_check"
                                :currentUser="currentUser"
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_expiration_date_first)"
                                @input="handleCheckBoxValue('contents_of_report_expiration_date', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                v-model="dataObject.contents_of_report_expiration_date.secondary_check"
                                :currentUser="currentUser"
                                :disabled="
                                    isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_expiration_date_secondary)
                                "
                                @input="handleCheckBoxValue('contents_of_report_expiration_date', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['■応募数報告その他先_2']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_2(dataObject)['■応募数報告その他先_2']"
                            @change="toggleCommonSwitch($event, { free_block_report_number: dataObject.free_block_report_number })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_report_number.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['■応募数報告その他先_2']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['■応募数報告その他先_2'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_report_number.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-■応募数報告その他先_2-${idTab}`"
                            :model.sync="dataObject.free_block_report_number.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['■応募数報告その他先_2'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
                <tr>
                    <th colspan="4">■その他(特記)</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['無効内容の詳細']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                v-model="SWITCH_FIELD_TAB_2(dataObject)['無効内容の詳細']"
                                switch
                                @change="toggleCommonSwitch($event, { invalid_content: dataObject.invalid_content })"
                            />
                            無効内容の詳細
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab2-textarea-5"
                            :model.sync="dataObject.invalid_content.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['無効内容の詳細']"
                            :isPreview="isPreview"
                            :config="inputConfig.invalid_content"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            v-model="dataObject.invalid_content.first_check"
                            :currentUser="currentUser"
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.invalid_content_first)"
                            @input="handleCheckBoxValue('invalid_content', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            v-model="dataObject.invalid_content.secondary_check"
                            :currentUser="currentUser"
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.invalid_content_secondary)"
                            @input="handleCheckBoxValue('invalid_content', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['その他連絡事項']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                v-model="SWITCH_FIELD_TAB_2(dataObject)['その他連絡事項']"
                                switch
                                @change="toggleCommonSwitch($event, { other_information: dataObject.other_information })"
                            />
                            その他連絡事項
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab2-textarea-6"
                            :model.sync="dataObject.other_information.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['その他連絡事項']"
                            :isPreview="isPreview"
                            :config="inputConfig.other_information"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            v-model="dataObject.other_information.first_check"
                            :currentUser="currentUser"
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_information_first)"
                            @input="handleCheckBoxValue('other_information', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            v-model="dataObject.other_information.secondary_check"
                            :currentUser="currentUser"
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_information_secondary)"
                            @input="handleCheckBoxValue('other_information', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_2(dataObject, isPreview)['フリーブロックその他先']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_2(dataObject)['フリーブロックその他先']"
                            @change="toggleCommonSwitch($event, { free_block_other: dataObject.free_block_other })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_other.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['フリーブロックその他先']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['フリーブロックその他先'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div v-if="isNotCheckBoxPartner || isDisabled" class="box--text__disabled" v-html="dataObject.free_block_other.data"></div>
                        <Editor
                            v-else
                            :id="`editor-${idTab}`"
                            :model.sync="dataObject.free_block_other.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_2(dataObject)['フリーブロックその他先'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { InputText } from '@/components/Input';

import CommonMultiselect from './CommonMultiselect.vue';
import Editor from '@/components/Editor/main.vue';
import editorDelayMixin from '@/mixins/editorDelayMixin';
import CommonCheckbox from './CommonCheckbox.vue';
import TextareaComponent from '@/components/Textarea/main.vue';

import {
    formatDateTimeJapanese,
    toggleCommonSwitch,
    isVisibleFieldInTab,
    isRolePartner,
    onHandleDataCheckValueForPartner
} from '@/views/pages/require/handlers';
import { SWITCH_FIELD_TAB_2, configHelperOptions, CONFIG_INPUT_TAB_2 } from '@/views/pages/require/const-field-tab';

export default {
    name: 'Tab2Require',
    mixins: [editorDelayMixin],
    props: {
        idTab: {
            type: [String, Number],
            default: ''
        },
        dataObject: {
            type: Object,
            required: false
        },
        currentUser: {
            type: Object,
            required: false
        },
        detailBeginForDocument: {
            type: Object,
            required: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isPreview: {
            type: Boolean,
            default: () => false
        },
        isNotCheckBoxPartner: {
            type: Boolean,
            default: () => false
        },
        keyTab: {
            type: [String],
            default: ''
        },
        processingFields: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        CommonMultiselect,
        Editor,
        CommonCheckbox,
        InputText,
        TextareaComponent
    },
    data() {
        return {
            option: configHelperOptions.optionTab2,
            isRolePartner: isRolePartner(),
            inputConfig: CONFIG_INPUT_TAB_2()
        };
    },
    methods: {
        formatDateTimeJapanese,
        toggleCommonSwitch,
        isVisibleFieldInTab,
        SWITCH_FIELD_TAB_2,

        handleCheckBoxValue(fieldName, type) {
            const payload = onHandleDataCheckValueForPartner(this.keyTab, this.dataObject, fieldName);
            this.$emit('handleTabCheckBoxValue', { payload, fieldName, type });
        }
    },
    watch: {},
    mounted() {}
};
</script>

<style lang="scss" scoped>
.box8 input[type='text'] {
    width: 200px;
}
</style>
